import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { compose } from "recompose";

import { PrimaryRedButton } from "nvent-web/components/Button";
import Heading from "../../components/Heading";
import { RegistrationFlow } from "../../stores/RegistrationFlow";
import style from "./ConfirmationStep.module.scss";

export interface ConfirmationStepInnerProps {
  registration: RegistrationFlow;
}

class ConfirmationStepInner extends Component<ConfirmationStepInnerProps> {
  render() {
    return (
      <>
        <Heading
          title={<FormattedMessage id="confirmation.heading" />}
          description={<FormattedMessage id="confirmation.description" />}
          className={style.heading}
        />
        <PrimaryRedButton
          type="button"
          size="large"
          fixedWidth
          onClick={this.props.registration.registrationConfirmed}
          className={style.button}
        >
          <FormattedMessage id="confirmation.ok" />
        </PrimaryRedButton>
      </>
    );
  }
}

const ConfirmationStep = compose<ConfirmationStepInnerProps, {}>(
  inject("registration"),
  observer
)(ConfirmationStepInner);

export default ConfirmationStep;
